import type { PnlTieLine } from "./api";

const SOLD_TIE_LABEL: Record<string, string> = {
  intercompany_cases_excluded: "Intercompany cases, excluded by rule",
  cost_of_product_no_units: "Cost of Product with no units sold",
  units_timing: "Units timing (sheet quantity vs units sold)",
  xero_not_in_sheet: "Xero Cost of Goods Sold not in the sheet",
  no_sales_this_month: "No sales this month",
  covered_by_pcogs_records: "Covered by the production-cost records (Trade)",
};
const SOLD_TIE_NOTE: Record<string, string> = {
  intercompany_cases_excluded: "Case rows not matched to a Shopify order (DEC-1411)",
};
const SOLD_TIE_REASON: Record<string, string> = {
  not_calculated: "Not calculated for this month yet.",
  waiting_for_sheet: "Waiting for the product cost sheet.",
  no_live_xero: "Live Xero returned nothing for this month, so there is no tie.",
};

export function soldTieLabel(line: PnlTieLine): { label: string; note?: string } {
  if (line.kind === "xero_changed_since_close") return { label: `Xero changed since the close: ${line.account_name}` };
  if (line.kind === "xero_not_in_close") return { label: `In Xero, not in the close: ${line.account_name}` };
  return { label: SOLD_TIE_LABEL[line.kind] ?? `Other difference (${line.kind})`, note: SOLD_TIE_NOTE[line.kind] };
}

export function soldTieReason(reason: string): string {
  return SOLD_TIE_REASON[reason] ?? `No tie for this month (${reason}).`;
}
